import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";

// Lazy load Carousel to reduce initial bundle size
const Carousel = dynamic(
  () => import("react-responsive-carousel").then((mod) => mod.Carousel),
  { 
    ssr: false, // Client-only carousel
    loading: () => (
      <div style={{ width: "100%", height: "300px", backgroundColor: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>Loading images...</span>
      </div>
    )
  }
);
// import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ImagesCarouselProps } from "../../page/Interfaces";
import { Flex, Rate, Typography } from "antd";
// OPTIMIZED: Replaced @ant-design/icons with lightweight SVGs
import { MobileIcon } from "../Icons";
import Link from "next/link";
import Image from "next/image";

const { Text, Title } = Typography;
const ImagesCarousel: React.FC<ImagesCarouselProps> = ({
  name,
  imageUrl,
  imgHeight,
  isHovered,
  turf,
  contact,
  starRating,
  isLCP = false,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const rating = starRating ? parseFloat(starRating) : 0;
  const imgMeta = `${turf?.name} | ${turf?.city}  | TurfBooking`;

  const slideHeight =
    typeof imgHeight === "string" && imgHeight.trim().length > 0 ? imgHeight.trim() : "300px";

  const renderImages = () => {
    return imageUrl?.map((image, index) => {
      // Only the first image of the LCP card gets priority loading
      const shouldPrioritize = isLCP && index === 0;
      return (
        <div key={index} className="carousal-image" style={{ height: slideHeight }}>
          <Image
            alt={imgMeta}
            title={imgMeta}
            src={image}
            fill
            quality={95}
            sizes="(max-width: 768px) 100vw, 400px"
            style={{ objectFit: 'cover' }}
            className="image"
            priority={shouldPrioritize}
            loading={shouldPrioritize ? 'eager' : 'lazy'}
            {...(shouldPrioritize && { fetchPriority: 'high' as const })}
          />
        </div>
      );
    });
  };
  useEffect(() => {
    if (isHovered) {
      const interval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % imageUrl.length);
      }, 1500);
      return () => clearInterval(interval);
    } else {
      setCurrentSlide(0);
    }
  }, [isHovered, imageUrl]);

  return (
    <div
      style={{
        position: "relative",
        zIndex: "10",
      }}
    >
      <Rate
        style={{
          fontSize: 16,
        }}
        value={rating}
        allowHalf
        disabled
      />
      <Carousel
        showStatus={false}
        showThumbs={false}
        selectedItem={currentSlide}
        infiniteLoop={true}
        emulateTouch
        showArrows={false}
        {...({} as any)}
      >
        {renderImages()}
      </Carousel>
      {name && (
        <Flex vertical className="carousal-title" align="flex-start">
          <Title level={4}>{name}</Title>
          <Flex gap={4} align="center">
            <MobileIcon size={14} />
            {contact.split("/").map((item: string, index: number) => {
              return (
                <React.Fragment key={index}>
                  {index > 0 && "/"}
                  <a href={`tel:+91${item}`}>+91 {item}</a>
                </React.Fragment>
              );
            })}
            {/* <a href={`tel:${contact}`}>+91 {contact}</a> */}
          </Flex>
        </Flex>
      )}
    </div>
  );
};

export default ImagesCarousel;
